import React from 'react';

function BrandMark({ className = '' }) {
  return (
    <span className={`brand-mark ${className}`.trim()}>
      rentual<span className="brand-mark-accent">.co</span>
    </span>
  );
}

export default BrandMark;
